import { render } from "./AddIsoPhase.vue?vue&type=template&id=ca5f7dd6"
import script from "./AddIsoPhase.vue?vue&type=script&lang=js"
export * from "./AddIsoPhase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__